export const isValidUser = (user: any) => {
  return Object.keys(user).length > 1
}
